// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Trash2 } from "lucide-react";
// import { toast } from "sonner";
// import Swal from "sweetalert2";
// import { Api } from "../Api/Api";

// export default function CreateIDPage() {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [photoBase64, setPhotoBase64] = useState("");
//   const [workers, setWorkers] = useState([]);
//   const [phone, setPhone] = useState("");
//   const [address, setAddress] = useState("");

//   const fetchWorkers = async () => {
//     try {
//       const res = await axios.get(`${Api}worker/get_all.php`);
//       console.log("Fetched workers:", res.data);

//       if (Array.isArray(res.data)) {
//         setWorkers(res.data);
//       } else {
//         toast.error("Invalid workers data");
//         setWorkers([]); // fallback
//       }
//     } catch (err) {
//       console.error("Error fetching workers:", err);
//       toast.error("Failed to load workers");
//       setWorkers([]); // fallback to avoid map crash
//     }
//   };

//   useEffect(() => {
//     fetchWorkers();
//   }, []);

//   const handleCreateID = async () => {
//     if (!username || !password) {
//       toast.error("Please fill in all fields");
//       return;
//     }

//     try {
//       const res = await axios.post(`${Api}worker/create.php`, {
//         username,
//         password,
//         phone,
//         address,
//         photo: photoBase64,
//       });

//       toast.success(`Worker ID ${res.data.id} created successfully`);
//       setUsername("");
//       setPassword("");
//       setPhone("");
//       setAddress("");
//       setPhotoBase64("");
//       fetchWorkers();
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Error creating worker");
//     }
//   };

//   const handleDeleteWorker = async (workerId) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Do you really want to delete Worker ID ${workerId}?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           await axios.delete(`${Api}worker/delete.php?id=${workerId}`);
//           Swal.fire(
//             "Deleted!",
//             `Worker ID ${workerId} has been deleted.`,
//             "success"
//           );
//           fetchWorkers();
//         } catch (err) {
//           Swal.fire("Error!", "Failed to delete worker.", "error");
//         }
//       }
//     });
//   };
//   const handlePhotoChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       setPhotoBase64(reader.result); // base64 string
//     };
//     reader.readAsDataURL(file);
//   };

//   return (
//     <div className="space-y-6">
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-3">
//         {/* Create Form */}
//         <div className="bg-white rounded-xl shadow p-6 space-y-4 h-[500px] overflow-y-auto custom-scrollbar">
//           <h2 className="text-xl font-semibold">Create New Worker ID</h2>

//           <div className="space-y-2">
//             <label htmlFor="username" className="block font-medium text-sm">
//               Username
//             </label>
//             <input
//               id="username"
//               className="w-full border px-3 py-2 rounded"
//               value={username}
//               onChange={(e) => setUsername(e.target.value)}
//               placeholder="Enter username"
//             />
//           </div>

//           <div className="space-y-2">
//             <label htmlFor="password" className="block font-medium text-sm">
//               Password
//             </label>
//             <input
//               id="password"
//               type="password"
//               className="w-full border px-3 py-2 rounded"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               placeholder="Enter password"
//             />
//           </div>

//           <div className="space-y-2">
//             <label htmlFor="phone" className="block font-medium text-sm">
//               Phone Number
//             </label>
//             <input
//               id="phone"
//               type="text"
//               className="w-full border px-3 py-2 rounded"
//               value={phone}
//               onChange={(e) => setPhone(e.target.value)}
//               placeholder="Enter phone number"
//             />
//           </div>

//           <div className="space-y-2">
//             <label htmlFor="address" className="block font-medium text-sm">
//               Address
//             </label>
//             <textarea
//               id="address"
//               className="w-full border px-3 py-2 rounded"
//               value={address}
//               onChange={(e) => setAddress(e.target.value)}
//               placeholder="Enter address"
//             />
//           </div>

//           <div className="space-y-2">
//             <label htmlFor="photo" className="block font-medium text-sm">
//               Photo
//             </label>
//             <input
//               type="file"
//               accept="image/*"
//               id="photo"
//               className="w-full border px-3 py-2 rounded"
//               onChange={handlePhotoChange}
//             />
//           </div>

//           <button
//             onClick={handleCreateID}
//             className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 rounded"
//           >
//             Create Worker ID
//           </button>
//         </div>

//         {/* Workers List */}
//         <div className="bg-white rounded-xl shadow p-6 h-[500px] flex flex-col">
//           <h2 className="text-xl font-semibold mb-4">
//             Existing Workers ({workers.length})
//           </h2>
//           <div className="space-y-3 flex-1 overflow-y-auto custom-scrollbar">
//             {workers.length > 0 ? (
//               workers.map((worker) => (
//                 <div
//                   key={worker.id}
//                   className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
//                 >
//                   <div className="flex items-center space-x-3">
//                     {worker.photo && (
//                       <img
//                         src={worker.photo}
//                         alt="photo"
//                         className="w-12 h-12 rounded-full object-cover"
//                       />
//                     )}
//                     <div>
//                       <p className="font-medium">{worker.id}</p>
//                       <p className="text-sm text-gray-600">
//                         Username: {worker.username}
//                       </p>
//                       <p className="text-xs text-gray-500">
//                         Created:{" "}
//                         {new Date(worker.created_at).toLocaleDateString()}
//                       </p>
//                     </div>
//                   </div>
//                   <button
//                     onClick={() => handleDeleteWorker(worker.id)}
//                     className="text-red-600 hover:bg-red-100 rounded-full p-2"
//                   >
//                     <Trash2 className="h-4 w-4" />
//                   </button>
//                 </div>
//               ))
//             ) : (
//               <p className="text-gray-500 text-center py-4">
//                 No workers created yet
//               </p>
//             )}
//           </div>
//           <style>
//             {`
//   .custom-scrollbar::-webkit-scrollbar {
//     width: 5px;          /* thin scrollbar */
//   }
//   .custom-scrollbar::-webkit-scrollbar-thumb {
//     background-color: rgba(0, 0, 0, 0.2); /* light gray thumb */
//     border-radius: 10px;
//   }
//   .custom-scrollbar::-webkit-scrollbar-track {
//     background: transparent; /* no background */
//   }

//   /* Firefox support */
//   .custom-scrollbar {
//     scrollbar-width: thin;
//     scrollbar-color: rgba(0,0,0,0.2) transparent;
//   }
// `}
//           </style>
//           ;
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import axios from "axios";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import Swal from "sweetalert2";
import { Api } from "../Api/Api";

export default function CreateIDPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [photoBase64, setPhotoBase64] = useState("");
  const [workers, setWorkers] = useState([]);
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [dob, setDob] = useState(""); // ✅ new state
  const [mainID, setMainID] = useState("");
  const [org1, setOrg1] = useState("");
  const [org2, setOrg2] = useState("");

  const fetchWorkers = async () => {
    try {
      const res = await axios.get(`${Api}worker/get_all.php`);
      if (Array.isArray(res.data)) {
        setWorkers(res.data);
      } else {
        toast.error("Invalid workers data");
        setWorkers([]);
      }
    } catch (err) {
      toast.error("Failed to load workers");
      setWorkers([]);
    }
  };

  useEffect(() => {
    fetchWorkers();
  }, []);

  // const handleCreateID = async () => {
  //   if (!username || !password) {
  //     toast.error("Please fill in all fields");
  //     return;
  //   }

  //   try {
  //     const res = await axios.post(`${Api}worker/create.php`, {
  //       username,
  //       password,
  //       phone,
  //       address,
  //       photo: photoBase64,
  //       dob, // ✅ send dob
  //     });

  //     toast.success(`Worker ID ${res.data.id} created successfully`);
  //     setUsername("");
  //     setPassword("");
  //     setPhone("");
  //     setAddress("");
  //     setPhotoBase64("");
  //     setDob("");
  //     fetchWorkers();
  //     setMainID("");
  //     setOrg1("");
  //     setOrg2("");
  //   } catch (err) {
  //     toast.error(err.response?.data?.message || "Error creating worker");
  //   }
  // };

  const handleCreateID = async () => {
    if (!username || !password) {
      toast.error("Please fill in all fields");
      return;
    }

    try {
      const res = await axios.post(`${Api}worker/create.php`, {
        username,
        password,
        phone,
        address,
        photo: photoBase64,
        dob,
        main_id: mainID, // ✅ Added
        org1, // ✅ Added
        org2, // ✅ Added
      });

      toast.success(`Worker ID ${res.data.id} created successfully`);
      setUsername("");
      setPassword("");
      setPhone("");
      setAddress("");
      setPhotoBase64("");
      setDob("");
      setMainID("");
      setOrg1("");
      setOrg2("");
      fetchWorkers();
    } catch (err) {
      toast.error(err.response?.data?.message || "Error creating worker");
    }
  };

  const handleDeleteWorker = async (workerId) => {
    // Step 1: Confirm deletion intent
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: `Do you really want to delete Worker ID ${workerId}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, continue",
    });

    if (!confirmResult.isConfirmed) return;

    // Step 2: Ask for admin credentials
    const { value: credentials } = await Swal.fire({
      title: "Admin Verification",
      html: `
      <input type="text" id="swal-username" class="swal2-input" placeholder="Admin Username" />
      <input type="password" id="swal-password" class="swal2-input" placeholder="Admin Password" />
    `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Verify & Delete",
      preConfirm: () => {
        const username = document.getElementById("swal-username").value;
        const password = document.getElementById("swal-password").value;

        if (!username || !password) {
          Swal.showValidationMessage("Please enter both username and password");
          return false;
        }
        return { username, password };
      },
    });

    if (!credentials) return;

    try {
      // Step 3: Verify admin credentials
      const verifyRes = await axios.post(`${Api}admin/login.php`, {
        username: credentials.username,
        password: credentials.password,
      });

      if (!verifyRes.data || !verifyRes.data.token) {
        Swal.fire("Error!", "Invalid admin credentials!", "error");
        return;
      }

      // Step 4: Proceed to delete worker
      await axios.delete(`${Api}worker/delete.php?id=${workerId}`);

      Swal.fire(
        "Deleted!",
        `Worker ID ${workerId} has been deleted successfully.`,
        "success"
      );

      fetchWorkers();
    } catch (err) {
      console.error(err);
      Swal.fire("Error!", "Failed to verify admin or delete worker.", "error");
    }
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setPhotoBase64(reader.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-3">
        {/* Create Form */}
        <div className="bg-white rounded-xl shadow p-6 space-y-4 h-[500px] overflow-y-auto custom-scrollbar">
          <h2 className="text-xl font-semibold">Create New Worker ID</h2>

          {/* Username */}
          <div className="space-y-2">
            <label htmlFor="username" className="block font-medium text-sm">
              Username
            </label>
            <input
              id="username"
              className="w-full border px-3 py-2 rounded"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
            />
          </div>

          {/* Password */}
          <div className="space-y-2">
            <label htmlFor="password" className="block font-medium text-sm">
              Password
            </label>
            <input
              id="password"
              type="password"
              className="w-full border px-3 py-2 rounded"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
          </div>

          {/* DOB */}
          <div className="space-y-2">
            <label htmlFor="dob" className="block font-medium text-sm">
              Date of Birth
            </label>
            <input
              id="dob"
              type="date"
              className="w-full border px-3 py-2 rounded"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
            />
          </div>

          {/* Phone */}
          <div className="space-y-2">
            <label htmlFor="phone" className="block font-medium text-sm">
              Phone Number
            </label>
            <input
              id="phone"
              type="text"
              className="w-full border px-3 py-2 rounded"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Enter phone number"
            />
          </div>

          {/* Address */}
          <div className="space-y-2">
            <label htmlFor="address" className="block font-medium text-sm">
              Address
            </label>
            <textarea
              id="address"
              className="w-full border px-3 py-2 rounded"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              placeholder="Enter address"
            />
          </div>

          {/* Main ID */}
          <div className="space-y-2">
            <label htmlFor="mainID" className="block font-medium text-sm">
              Main ID
            </label>
            <input
              id="mainID"
              type="text"
              className="w-full border px-3 py-2 rounded"
              value={mainID}
              onChange={(e) => setMainID(e.target.value)}
              placeholder="Enter Main ID"
            />
          </div>

          {/* ORG 1 */}
          <div className="space-y-2">
            <label htmlFor="org1" className="block font-medium text-sm">
              ORG 1
            </label>
            <input
              id="org1"
              type="text"
              className="w-full border px-3 py-2 rounded"
              value={org1}
              onChange={(e) => setOrg1(e.target.value)}
              placeholder="Enter ORG 1"
            />
          </div>

          {/* ORG 2 */}
          <div className="space-y-2">
            <label htmlFor="org2" className="block font-medium text-sm">
              ORG 2
            </label>
            <input
              id="org2"
              type="text"
              className="w-full border px-3 py-2 rounded"
              value={org2}
              onChange={(e) => setOrg2(e.target.value)}
              placeholder="Enter ORG 2"
            />
          </div>

          {/* Photo */}
          <div className="space-y-2">
            <label htmlFor="photo" className="block font-medium text-sm">
              Photo
            </label>
            <input
              type="file"
              accept="image/*"
              id="photo"
              className="w-full border px-3 py-2 rounded"
              onChange={handlePhotoChange}
            />
          </div>

          <button
            onClick={handleCreateID}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 rounded"
          >
            Create Worker ID
          </button>
        </div>

        {/* Workers List */}
        <div className="bg-white rounded-xl shadow p-6 h-[500px] flex flex-col">
          <h2 className="text-xl font-semibold mb-4">
            Existing Workers ({workers.length})
          </h2>
          <div className="space-y-3 flex-1 overflow-y-auto custom-scrollbar">
            {workers.length > 0 ? (
              workers.map((worker) => (
                <div
                  key={worker.id}
                  className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
                >
                  <div className="flex items-center space-x-3">
                    {worker.photo && (
                      <img
                        src={worker.photo}
                        alt="photo"
                        className="w-12 h-12 rounded-full object-cover"
                      />
                    )}
                    <div>
                      <p className="font-medium">{worker.id}</p>
                      <p className="text-sm text-gray-600">
                        Username: {worker.username}
                      </p>
                      <p className="text-xs text-gray-500">
                        DOB: {worker.dob || "N/A"}
                      </p>
                      <p className="text-xs text-gray-500">
                        Created:{" "}
                        {new Date(worker.created_at).toLocaleDateString()}
                      </p>
                      <p className="text-xs text-gray-500">
                        Main ID: {worker.main_id || "N/A"}
                      </p>
                      <p className="text-xs text-gray-500">
                        ORG 1: {worker.org1 || "N/A"}
                      </p>
                      <p className="text-xs text-gray-500">
                        ORG 2: {worker.org2 || "N/A"}
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => handleDeleteWorker(worker.id)}
                    className="text-red-600 hover:bg-red-100 rounded-full p-2"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              ))
            ) : (
              <p className="text-gray-500 text-center py-4">
                No workers created yet
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
